import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { INotificationSettings } from './notificationsettings-model';

@Injectable()
export class NotificationSettingsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'notificationsettings';

    /** GET */
    public getNotificationSettings(): Observable<SuccessResponse<INotificationSettings> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<INotificationSettings>>(
                NotificationSettingsService.URL +
                NotificationSettingsService.ENDPOINT
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    /** PUT */
    public updateNotificationSettings(notificationSettings: INotificationSettings): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(
                NotificationSettingsService.URL +
                NotificationSettingsService.ENDPOINT,
                notificationSettings
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

}
